import React from 'react';
import { useRef } from 'react';

/**
 * @typedef {object} ResponsiveTabProps
 * @property {string} [id]
 * @property {Object|string} children
 * @property {boolean} [active]
 * @property {(event: React.MouseEvent<HTMLButtonElement>) => void} [onClick]
 * @property {string} [dataTestId]
 */

/**
 * @param {ResponsiveTabProps} props
 */
const ResponsiveTab = props => {
  const { id, active, onClick, children, dataTestId } = props;
  const ref = useRef(null);

  return (
    <button
      id={id}
      ref={ref}
      data-testid={dataTestId}
      className={'tabs-menu__tab-button' + (active ? ' tabs-menu__tab-button--active' : '')}
      onClick={onClick}>
      <div className='tabs-menu__tab-fade' />
      {children}
    </button>
  );
};

export default ResponsiveTab;
